<template>
  <div class="checkbox-group" :class="{ 'version2-style': !!style }">
    <input type="checkbox"
           :checked="checked"
           :id="id" :name="id"
           @input="input($event)">
    <label :for="id">
      <i class="checked xi-check-circle"></i>
      <i v-if="!style" class="unchecked xi-check-circle-o"></i>
      <span><slot></slot></span>
    </label>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: Boolean,
    id: String,
    onChecked: Function,
    style: String
  },
  methods: {
    input(event) {
      this.$emit('update:checked', event.target.checked)

      if (event.target.checked && this.onChecked) {
        this.onChecked();
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .checkbox-group {
    input[type="checkbox"] {
      opacity: 0;
      width: 0;

      + label i.checked {
        display: none;
      }

      &:checked {
        + label i.checked {
          display: inline-block;
        }

        + label i.unchecked {
          display: none;
        }
      }
    }

    i {
      font-size: 18px;
      vertical-align: top;
      //padding-top: 1px;

      &.checked {
        color: $main-color;
      }

      &.unchecked {
        color: #7f7f7f;
      }

      @include respond(mobile) {
        font-size: 12px;
      }
    }

    span {
      vertical-align: top;
      padding-left: 10px;
      @include drag-disable();

      @include respond(mobile) {
        padding-left: 5px;
      }
    }

    &.version2-style {
      input[type="checkbox"] {
        + label {
          i.checked {
            display: inline-block;
            color: rgba(0, 0, 0, 0.2);
            font-size: 25px;
            vertical-align: top;
          }

          span {
            line-height: 25px;
          }
        }

        &:checked + label i {
          color: $sub-color;
        }
      }

    }
  }
</style>
